import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { fuseAnimations } from '../../../../../../../core/animations';

/**Service file */
import { EcommerceOrdersService } from '../../orders.service';

/**Local component */
import { ToastComponent } from '../../../../common/toast.component';

/**Local file */
import { displayValues, apiCalls, toastMsg } from '../../../../utils/index';

@Component({
    selector: 'bottom-side',
    templateUrl: './bottom-sidenav.component.html',
    styleUrls: ['./bottom-sidenav.component.scss'],
    animations: fuseAnimations
})
export class OrdersBottomComponent implements OnInit, OnDestroy {

    displayValues = displayValues;
    apiCalls = apiCalls;
    toastMsg = toastMsg;

    constructor(
        public ordersService: EcommerceOrdersService,

        /** Local component */
        public toastComponent: ToastComponent,
    ) {

    }

    ngOnInit() {

    }

    postFacebook() {
        window.open(this.apiCalls.fbPost, '_blank');
    }
    uploadToYoutube() {
        // Set current todo
        // this.ordersService.setCurrentTodo('youtube'); //not worked properly
        // Show the success message
        this.toastComponent.showToast(this.toastMsg.notEstablished);
    }

    promotionCodes() {
        window.open(this.apiCalls.wpCouponSite, '_blank');
    }

    sendEblast() {
        // Show the success message
        this.toastComponent.showToast(this.toastMsg.notEstablished);
    }

    openWebinar() {
        // Show the success message
        this.toastComponent.showToast(this.toastMsg.notEstablished);
    }
    uploadVideoToSite() {
        // Show the success message
        this.toastComponent.showToast(this.toastMsg.notEstablished);
    }

    ngOnDestroy() {

    }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/bottom/bottom-sidenav.component.ts